import styled from 'styled-components';

export const Container = styled.div`
  height: calc(100vh - 8rem);
  width: 100%;
  margin-top: 4rem;
  background-color: var(--gray-background);

  @media (max-width: 850px) {
    height: calc(100vh - 4rem);
  }
`;

export const Content = styled.div`
  padding: 1rem 10rem;
  max-width: 100%;
  justify-content: space-between;
  max-height: calc(100vh - 8rem);

  .first-header-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 1400px;
    margin: 0 auto;

    a {
      text-decoration: none;
      background-color: var(--light-blue);
      color: white;
      border: var(--light-blue);
      padding: 0.3rem 1rem;
      font-size: 1rem;
      border-radius: 0.3rem;
      -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
      -moz-box-shadow: rgba(0,0,0,0.3) 0 1px 3px;
      box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    }
  }

  .pages-child {
    margin: 0 auto;
    max-width: 1400px;
  }

  .body {
    margin-top: 1rem;
    padding: 0 .4rem;

    p {
      strong {
        color: var(--dark-blue);
      }
      margin-bottom: 1rem;
    }

  }

  @media (max-width: 720px) {
    padding: 1rem 2rem;
  }

  @media (min-width: 1100px) {
    .charts-body {
      display: flex;
      justify-content: center;
      gap: 2rem;

      .atual-day {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 0 1rem;
      }
    }
  }

  @media (max-width: 520px) {
    .main-chart {
      width: calc(100% + 4rem);
      margin-left: -2rem;
      p {
        padding: 1rem;
      }
    }

    .secondary-charts {
      position: absolute;
      left: 0;
      padding: 1rem 1rem 0;
      width: 101%;
      margin-top: -1.8rem;
      background: var(--gray-background);
      border-radius: .5rem;
    }
  }
`;
